import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import AddUnitOfMeasurement from "./AddUnitOfMeasurement";

const UnitOfMeasurement = () => {
  const { t } = useTranslation();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [unitOfMeasurementId, setUnitOfMeasurementId] = useState(null);
  const [categoryTree, setCategoryTree] = useState([]);
  const [subCategoryTree, setSubCategoryTree] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalKey, setModalKey] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  //State initiailisation
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // Fetch the Unit of Mesurement
  useEffect(() => {
    const getUnitOfMeasurement = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("unit-of-measurement/", state);

        if (apiResponse.data.results.success) {
          setUnitOfMeasurement(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_unit_of_measurement"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getUnitOfMeasurement();
  }, [state, reload, t]);

  // Fetch the category tree on component mount
  useEffect(() => {
    getCategoryTree();
    // getSubCategoryTree();
  }, []);

  // Fetch the category tree data from the API
  const getCategoryTree = async (data) => {
    // await getRequest("category-tree/?no_pagination=True", data).then(
    await getRequest("category-tree/category-tree-list/?no_pagination=True", data).then(

      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };

  // const getSubCategoryTree = async (data) => {
  //   await getRequest("sub-category/?no_pagination=True", data).then(
  //     (response) => {
  //       setSubCategoryTree(response.data.data);
  //     }
  //   );
  // };

  // Handle changes in the table, including pagination, filters, sorting, and ordering
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

// Convert sorter field and order to API-compatible sorting enum
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree__name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree__name";
    }
    if (sortField === "unit_of_measurement" && sortOrder === "ascend") {
      sortingEnumKey = "unit_of_measurement";
    }
    if (sortField === "unit_of_measurement" && sortOrder === "descend") {
      sortingEnumKey = "-unit_of_measurement";
    }

    return sortingEnumKey;
  };

  // Callback for handling search input with debounce
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  // Perform search operation and update state
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

// Row selection configuration for the table
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  // Function to handle editing an item
  const handleEdit = (id) => {
    setModalKey((prevKey) => !prevKey);
    setUnitOfMeasurementId(id);
    showModal();
  };

  // Function to handle adding a new item
  const handleAdd = () => {
    setUnitOfMeasurementId(null);
    showModal();
    setState({ ...state, ordering: "id" });
    setReload((reload) => !reload);
  };
// Function to handle archiving selected items
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("unit-of-measurement-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("unit_of_measurement_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  // Function to show the modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Function to handle modal OK button click
  const handleOk = () => {
    setIsModalOpen(false);
  };

  // Function to handle modal Cancel button click
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    // {
    //   title: "Sub Category",
    //   dataIndex: "sub_category_name",
    //   key: "sub_category_name",
    //   sorter: true,
    // },
    {
      title: "Unit Of Measurement",
      dataIndex: "unit_of_measurement",
      key: "unit_of_measurement",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      width: "100px",
      render: (text, record) => (
        <Space>
           <Tooltip
            color={colors}
            placement="left"
            title={
              <span style={{ color: "#fff" }}>
                Edit
              </span>
            }
          >
          {authUserData()?.permission.includes(
            "unit_of_measurement|change_unitofmeasurements"
          ) && <Editicon onClick={() => handleEdit(record.id)} style={{ cursor: "pointer" }}  />}
          </Tooltip>
          <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Archive
              </span>
            }
          >
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            {authUserData()?.permission.includes(
              "unit_of_measurement|delete_unitofmeasurements"
            ) && <Archive style={{ cursor: "pointer" }} />}
          </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
              <h3>{t("label_unit_of_measurement")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {t("label_unit_of_measurement")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>
              </Space>
            </div>
            {authUserData()?.permission.includes(
              "unit_of_measurement|add_unitofmeasurements"
            ) && (
              <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                 Add a new unit of measurement for specifying quantities or dimensions within your project or system.
                </span>
              }
            >
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={handleAdd}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_unit_of_measurement")}
                </Button>
                </Tooltip>
              )}
            <Modal
              className="ModelPopupSec"
             // title="Add Unit Of Measurement"
              title={unitOfMeasurementId ? t("Edit UoM.") : t("Add Unit Of Measurement")}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
            >
              <AddUnitOfMeasurement
                categoryTree={categoryTree}
                handleCancel={handleCancel}
                setReload={setReload}
                unitOfMeasurementId={unitOfMeasurementId}
                modalKey={modalKey}
                setStateM = {setState}
                subCategoryTree= {subCategoryTree}
              />
            </Modal>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "unit_of_measurement|delete_unitofmeasurements"
                ) && (
                    <ButtonField
                      type="primary"
                      htmlType="button"
                      className="BlueShadowBtn"
                      label={t("archiveList")}
                    />
                  )}
              </Popconfirm>
            )}

            <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/unit-of-measurement/archive">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Space>
        </div>
      </div>
      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            >
            </Col>
          </Row>
<div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={unitOfMeasurement}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
        </div>
        </div>
      </section>
    </>
  );
};
export default UnitOfMeasurement;
